var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "13px",
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-263.000000, -240.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(263.000000, 240.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 13,
    height: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.324,9.776 L7.722,2.08 C7.046,0.962 5.98,0.962 5.304,2.08 L0.702,9.776 C0.026,10.894 0.546,11.778 1.846,11.778 L11.206,11.778 C12.48,11.778 12.974,10.868 12.324,9.776 Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.800000, 3.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.375,0 C0.167894531,0 -1.09139364e-11,0.167894531 -1.09139364e-11,0.375 C-1.09139364e-11,2.38008851 -1.09139364e-11,3.88129396 -1.09139364e-11,4.87861633 C-1.09139364e-11,5.14002991 0.225453695,5.25 0.338180542,5.25 C0.51302931,5.25 0.775302463,5.25 1.125,5.25 C1.33210547,5.25 1.5,5.08210547 1.5,4.875 C1.5,2.87063231 1.5,1.3674894 1.5,0.365571256 C1.5,0.168129764 1.4175821,0 1.11927325,0 C0.953879198,0 0.705788113,0 0.375,0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75,7.5 C1.16421094,7.5 1.5,7.16421094 1.5,6.75 C1.5,6.33578906 1.16421094,6 0.75,6 C0.335789062,6 0,6.33578906 0,6.75 C0,7.16421094 0.335789062,7.5 0.75,7.5 Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarn);
export default __webpack_public_path__ + "static/media/warn.9f7c0292079c23f0f850083281da6c88.svg";
export { ForwardRef as ReactComponent };